var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckStreamlineFlex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-1.43 -1.43 40 40",
    id: "Check--Streamline-Flex",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Check Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check--check-form-validation-checkmark-success-add-addition-tick"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.9896428571428573 22.71508928571429 14.048072357142857 35.150357142857146C19.72232155714286 18.850645757142857 24.447935571428573 11.6981715 35.150357142857146 1.9896428571428573",
    strokeWidth: 2.86
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckStreamlineFlex);
export default __webpack_public_path__ + "static/media/Check--Streamline-Flex.136e2789c4260a5fe9bd9f5dab1b3413.svg";
export { ForwardRef as ReactComponent };